/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventsLookup } from '../../models/harvest-events-lookup';

export interface GetFeedMillList$Params {
}

export function getFeedMillList(http: HttpClient, rootUrl: string, params?: GetFeedMillList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventsLookup>>> {
  const rb = new RequestBuilder(rootUrl, getFeedMillList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestEventsLookup>>;
    })
  );
}

getFeedMillList.PATH = '/api/harvesteventslookup/feed/mill';
